<template>
  <v-container class="contenedor-ppal">
    <v-overlay :value="sisi">
      <div class="loader"></div>
    </v-overlay>

    <!-- INFORMACION TOOLBAR  -->
    <v-card elevation="4" class="mb-5">
      <v-toolbar flat elevation="4">
        <v-card class="icon">
          <v-icon
            style="margin-left: 30px; margin-top: 25px"
            color="white"
            x-large=""
            >mdi-chart-bar</v-icon
          >
        </v-card>
        <div class="usuario">REPORTE GENERAL</div>
        
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>

    <!-- FILTROS POR FECHA -->
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 4" class="mb-2">
            <v-menu
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                color="1D3C7F"
                  v-model="dateInit"
                  label="Fecha inicio"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                color="#294697"
                v-model="dateInit"
                @input="menu1 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 4" class="mb-2">
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateEnd"
                  label="Fecha final"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateEnd"
                @input="menu2 = false"
                locale="es"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.xs ? 12 : 4" class="mb-2">
            <v-btn
              :block="$vuetify.breakpoint.xs"
              :disabled="!dateInit"
              @click="searchReports"
              color="#111c3d"
              dark
              class="btn-consultar"
              style="width: 100%;"
            >
              <v-icon left size="20">mdi-magnify</v-icon>
              <span v-if="!$vuetify.breakpoint.xs">Consultar</span>
              <span v-else>Buscar</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="d-flex justify-end">
            <div v-if="reportes.length != 0">
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="green darken-3"
                class="white--text btn-excel"
                @click="downloadExcelJS"
              >
                <v-icon left> mdi-file-excel </v-icon>
                EXPORTAR EXCEL
                <template v-slot:loader>
                  Exportando...
                  <span class="custom-loader">
                    <v-icon light>mdi-reload</v-icon>
                  </span>
                </template>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- FILTRO DE BÚSQUEDA (A LA DERECHA) - MÁS LARGO -->
    <v-row v-if="reportes.length != 0" class="mt-3">
      <v-col cols="12" class="d-flex justify-end">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Filtrar búsqueda general"
          class="text-field"
          single-line
          color="#111c3d"
          dense
          style="max-width: 600px;"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- TABLA PRINCIPAL CON TODOS LOS REPORTES -->
    <v-data-table
      v-if="reportes.length != 0"
      :headers="headers"
      :items="filteredReportes"
      :search="search"
      style="border: 2px solid #111c3d"
      class="elevation-3 mt-3"
      :items-per-page="15"
      :footer-props="{
        'items-per-page-options': [10, 15, 25, 50, 100]
      }"
    >
      <!-- Estado del caso (CORRECTO/ERRONEO) -->
      <template v-slot:item.estado_caso="{ item }">
        <v-chip :color="getEstadoColor(item)" outlined dark>
          <div class="mt-2" v-if="item.oculto == 0 && item.cerrados == 0">
            ERRONEO
          </div>
          <div v-else>CORRECTO</div>
        </v-chip>
      </template>

      <!-- Columna de acciones (CON TODOS LOS ICONOS) -->
      <template v-slot:item.action="{ item }">
        <!-- Icono: Ver detalles (conversación) -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="#111c3d"
              class="mr-2"
              @click.prevent="verConversacion(item)"
            >
              mdi-wechat
            </v-icon>
          </template>
          <span>Ver detalles</span>
        </v-tooltip>

        <!-- Icono: Ver observación (NUEVO) -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="light-green lighten-1"
              class="mr-2"
              @click.prevent="verObservacion(item)"
            >
              mdi-eye
            </v-icon>
          </template>
          <span>Ver observación</span>
        </v-tooltip>

        <!-- Icono: Ver imagen -->
        <v-tooltip v-if="item.cc_ruta && item.cc_ruta !== '' && item.cc_ruta !== '0'" right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="light-blue"
              class="mr-2"
              @click="verImagen(item)"
            >
              mdi-image
            </v-icon>
          </template>
          <span>Ver imagen de cierre</span>
        </v-tooltip>

        <!-- Icono: Ver historial (NUEVO) -->
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="purple"
              class="mr-2"
              @click.prevent="verHistorial(item)"
            >
              mdi-timeline-clock
            </v-icon>
          </template>
          <span>Ver historial</span>
        </v-tooltip>

        <!-- Icono: Eliminar (solo para casos erróneos) -->
        <v-tooltip v-if="item.oculto == 0 && item.cerrados == 0" right>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              medium
              color="red darken-2"
              @click.prevent="deleteReport(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Eliminar caso erróneo</span>
        </v-tooltip>
      </template>

      <!-- Sin datos -->
      <template v-slot:no-data>
        <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
          >No hay información para mostrar en las fechas seleccionadas</v-alert
        >
      </template>
    </v-data-table>

    <!-- Diálogo de conversación -->
    <v-row justify="center">
      <v-dialog v-model="dialog2" max-width="500px" persistent>
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-message-bulleted</v-icon>
              DETALLE DE REPORTE
            </span>
          </v-card-title>
          <v-card-text>
            <div v-for="(chat, index) in chatItem" :key="index">
              <v-card class="mt-3 mx-auto" width="550">
                <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                  <p class="indigo--text text--darken-3">
                    <v-icon color="indigo darken-4" class="ml-5 mr-1"
                      >mdi-robot</v-icon
                    >
                    {{ chat.user }}
                  </p>
                </v-card-subtitle>
                <v-card-subtitle v-else class="d-flex justify-end">
                  <p class="deep-purple--text text--accent-3">
                    <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                      >mdi-face</v-icon
                    >
                    {{ chat.user }}
                  </p>
                </v-card-subtitle>
                <v-card-text v-if="chat.user == 'NOVA'" class="">
                  <p class="grey--text text--darken-1 text-left">
                    {{ chat.message }}
                  </p>
                </v-card-text>
                <v-card-text v-else class="d-flex justify-end">
                  <p class="grey--text text--darken-1 text-right">
                    {{ chat.message }}
                  </p>
                </v-card-text>
              </v-card>
            </div>
            <v-divider class="mt-5"></v-divider>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="#1D3C7F"
              dark
              @click="verEvidencias(idCasoActual)"
              class="mr-2"
            >
              <v-icon left>mdi-image-multiple</v-icon>
              VER EVIDENCIAS
            </v-btn>
            <v-btn color="#1D3C7F" dark @click="dialog2 = false">CERRAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Diálogo de observación (NUEVO) -->
    <v-row justify="center">
      <v-dialog v-model="dialog3" max-width="500px" persistent>
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white">
              <v-icon color="white">mdi-message-bulleted</v-icon>
              OBSERVACIÓN DEL CASO
            </span>
          </v-card-title>
          <v-card-text class="pa-5">
            <p style="font-size: 18px; white-space: pre-wrap;">
              {{ observacion || "No se ingresó una observación para este caso" }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#1D3C7F" dark @click="close3">CERRAR</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Diálogo de evidencias -->
    <v-dialog v-model="dialogEvidencias" max-width="900px">
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image-multiple</v-icon>
            Evidencias del caso #{{ idCasoActual }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <div v-if="cargandoEvidencias" class="text-center my-5">
              <v-progress-circular
                indeterminate
                color="#294697"
              ></v-progress-circular>
              <p>Cargando evidencias...</p>
            </div>
            <div v-else-if="!evidencias.length" class="text-center my-5">
              <v-alert type="info" outlined>
                No hay evidencias disponibles para este caso.
              </v-alert>
            </div>
            <v-row v-else>
              <v-col
                v-for="(evidencia, index) in evidencias"
                :key="index"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card outlined>
                  <template v-if="isImageUrl(evidencia.cc_ruta_evidencia)">
                    <v-img
                      :src="evidencia.cc_ruta_evidencia"
                      aspect-ratio="1"
                      class="grey lighten-2"
                      @click="verImagenCompleta(evidencia.cc_ruta_evidencia)"
                      style="cursor: pointer"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="#294697"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </template>
                  <template v-else>
                    <v-card
                      class="d-flex flex-column align-center justify-center pa-3"
                      style="cursor: pointer; aspect-ratio: 1; height: 100%"
                      @click="downloadFile(evidencia.cc_ruta_evidencia)"
                    >
                      <v-icon size="80" color="grey darken-1"
                        >mdi-file-document-outline</v-icon
                      >
                      <div
                        class="mt-2 text-caption grey--text text--darken-1 text-center"
                        style="word-break: break-all"
                      >
                        {{ getFileName(evidencia.cc_ruta_evidencia) }}
                      </div>
                    </v-card>
                  </template>
                  <v-card-text class="pa-2">
                    <small class="grey--text">{{
                      formatDate(evidencia.fecha_subida)
                    }}</small>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="closeEvidencias">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de imagen completa -->
    <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
      <v-card flat>
        <v-toolbar dark color="#1D3C7F" flat>
          <v-btn icon dark @click="descargarImagen">
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-toolbar-title>Evidencia</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogImagenCompleta = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          class="pa-0 d-flex justify-center align-center"
          style="height: calc(100vh - 64px); background-color: #000"
        >
          <img
            :src="imagenSeleccionada"
            style="max-height: 95vh; max-width: 95vw; object-fit: contain"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de imagen de cierre -->
    <v-dialog
      v-model="dialogImagenCierre"
      max-width="500px"
      max-height="400px"
      persistent
    >
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-image</v-icon>
            Evidencia del Caso
          </span>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-img v-if="cc_ruta" :src="cc_ruta" alt="Imagen"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#294697" dark @click="dialogImagenCierre = false"
            >CERRAR</v-btn
          >
          <v-btn color="#1D3C7F" dark @click="aumentarImagen">Aumentar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Timeline de historial -->
    <CaseHistoryTimeline
      :caseId="idCasoActual"
      :visible.sync="dialogHistorial"
    />

    <!-- Snackbar de notificaciones -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      color="#111c3d"
      style="color: white"
    >
      {{ text }}
      <v-btn color="#111c3d" depressed @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import env from "@/components/env";
import swal from "sweetalert";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";

export default {
  name: "ReporteGeneral",
  components: {
    CaseHistoryTimeline,
  },
  data: () => ({
    // Configuración de usuario
    idCargo: parseInt(localStorage.getItem("idCargo")) || 0,
    idArea: parseInt(localStorage.getItem("idArea")) || 0,
    idEmpresaUsuario: parseInt(localStorage.getItem("idEmpresa")) || 0,
    
    // Snackbar
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    text: "",
    
    // Fechas
    dateInit: "",
    dateEnd: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    sisi: false,
    
    // Filtros
    selectedArea: null,
    search: "",
    
    // Áreas disponibles
    areasOptions: [],
    areasMap: {},
    
    // Headers de la tabla
    headers: [
      { text: "ID Caso", value: "cc_id_caso", align: "center", class: "column" },
      { text: "Área", value: "cc_nombre_area", align: "center", class: "column" },
      { text: "Requerimiento", value: "cc_nombre_requerimiento", align: "center", class: "column" },
      { text: "Estado", value: "estado_caso", align: "center", class: "column", sortable: false },
      { text: "IP", value: "ip", align: "center", class: "column" },
      { text: "Municipio", value: "municipio", align: "center", class: "column" },
      { text: "Punto", value: "punto", align: "center", class: "column" },
      { text: "Empresa", value: "nombreEmpresa", align: "center", class: "column" },
      { text: "Fecha apertura", value: "fecha_inicio", align: "center", class: "column" },
      { text: "Fecha cierre", value: "fecha_cierre", align: "center", class: "column" },
      { text: "Especialista", value: "nombre", align: "center", class: "column" },
      { text: "Acciones", value: "action", sortable: false, align: "center", class: "column" },
    ],
    
    // Datos
    reportes: [],
    filteredReportes: [],
    originalReportes: [],
    
    // Estados de carga
    loading3: false,
    cargando: false,
    timeoutId: null,
    
    // Diálogos
    dialog2: false,
    dialog3: false,
    dialogHistorial: false,
    chatItem: [],
    observacion: "",
    idCasoActual: null,
    
    // Evidencias
    dialogEvidencias: false,
    cargandoEvidencias: false,
    evidencias: [],
    
    // Imágenes
    imagenSeleccionada: "",
    dialogImagenCompleta: false,
    dialogImagenCierre: false,
    cc_ruta: "",
  }),
  
  computed: {
    tienePermiso() {
      return this.idCargo === 9;
    },
    
    empresaUsuarioTexto() {
      if (this.idEmpresaUsuario === 1) return "FACILISIMO";
      if (this.idEmpresaUsuario === 2) return "APOSTAR";
      return null;
    }
  },
  
  mounted() {
    if (!this.tienePermiso) {
      this.$router.push("/dashboard");
      this.$emit("show-snackbar", "No tiene permisos para acceder a esta vista");
      return;
    }
  },
  
  beforeDestroy() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  },
  
  methods: {
    getEstadoColor(item) {
      if (item.oculto == 0 && item.cerrados == 0) return "red darken-2";
      else return "green darken-3";
    },
    
    formatearEstado(cerrados) {
      const estados = {
        '0': 'ABIERTO',
        '1': 'SOLUCIONADO',
        '2': 'ASIGNADO',
        '3': 'SUSPENDIDO',
        '4': 'VENCIDO',
        '5': 'ANULADO'
      };
      return estados[cerrados] || 'DESCONOCIDO';
    },
    
    formatearPrioridad(prioridad) {
      const prioridades = {
        '1': 'BAJA',
        '2': 'MEDIA',
        '3': 'ALTA'
      };
      return prioridades[prioridad] || 'SIN PRIORIDAD';
    },
    
    searchReports() {
      if (!this.tienePermiso) {
        this.mostrarMensaje("No tiene permisos para realizar esta consulta");
        return;
      }
      
      // Limpiar timeout anterior
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      
      this.cargando = true;
      this.sisi = true;
      
      // 🔥 Timeout aumentado a 120 segundos (2 minutos)
      this.timeoutId = setTimeout(() => {
        if (this.cargando) {
          this.sisi = false;
          this.cargando = false;
          this.mostrarMensaje("La consulta está tomando demasiado tiempo. Intente con un rango de fechas más pequeño.");
        }
      }, 120000);
      
      const fechaInicio = this.dateInit;
      const fechaCierre = this.dateEnd;

      if (fechaInicio > fechaCierre) {
        this.mostrarMensaje("Error: La fecha de inicio no puede ser mayor a la fecha final");
        this.dateInit = "";
        this.reportes = [];
        this.sisi = false;
        this.cargando = false;
        clearTimeout(this.timeoutId);
        return;
      }

      console.log("Usuario - idCargo:", this.idCargo, "idEmpresa:", this.idEmpresaUsuario);

      axios
        .get(
          `${env.endpoint}callcenter/allReporteFecha?fechaInicio=${fechaInicio} 00:00:00&fechaFinal=${fechaCierre} 23:59:59`
        )
        .then((res) => {
          clearTimeout(this.timeoutId);
          this.sisi = false;
          this.cargando = false;
          
          let data = res.data || [];
          
          console.log("Total casos antes de filtrar:", data.length);
          
          // DEBUG: Ver primeros 3 casos
          console.log("Muestra de casos:", data.slice(0, 3).map(item => ({
            id: item.cc_id_caso,
            idEmpresa: item.idEmpresa,
            nombreEmpresa: item.nombreEmpresa,
            punto: item.punto,
            municipio: item.municipio,
            cc_ruta: item.cc_ruta
          })));
          
          // Contar por idEmpresa (convertir a número para el conteo)
          const porIdEmpresa = {};
          data.forEach(item => {
            const id = parseInt(item.idEmpresa);
            porIdEmpresa[id] = (porIdEmpresa[id] || 0) + 1;
          });
          console.log("Distribución por idEmpresa:", porIdEmpresa);
          
          // FILTRAR POR EMPRESA DEL USUARIO (CORREGIDO)
          if (this.idEmpresaUsuario === 1 || this.idEmpresaUsuario === 2) {
            data = data.filter(item => item.idEmpresa == this.idEmpresaUsuario);
            console.log("Casos después de filtrar por idEmpresa:", data.length);
          }
          
          // Si no hay datos después del filtro, mostrar mensaje
          if (data.length === 0) {
            this.mostrarMensaje(`No se encontraron casos de ${this.empresaUsuarioTexto} en el rango seleccionado`, 'info');
          }
          
          this.originalReportes = data;
          this.reportes = [...data];
          this.filteredReportes = [...data];
          
          this.construirOpcionesAreas(data);
          
          this.mostrarMensaje(
            `Se encontraron ${data.length} casos de ${this.empresaUsuarioTexto || 'TODAS'} en el rango seleccionado`, 
            'success'
          );
        })
        .catch((error) => {
          clearTimeout(this.timeoutId);
          this.sisi = false;
          this.cargando = false;
          console.error("Error al cargar reportes:", error);
          this.mostrarMensaje("Error al cargar los reportes. Por favor intente nuevamente.");
          this.reportes = [];
          this.filteredReportes = [];
        });
    },
    
    construirOpcionesAreas(data) {
      const areasSet = new Set();
      const areasMap = {};
      
      data.forEach(item => {
        if (item.cc_id_area_requerimiento && item.cc_nombre_area) {
          const id = item.cc_id_area_requerimiento;
          const nombre = item.cc_nombre_area;
          areasSet.add(id);
          areasMap[id] = nombre;
        }
      });
      
      this.areasMap = areasMap;
      
      const areasArray = Array.from(areasSet).sort((a, b) => {
        const nombreA = areasMap[a] || '';
        const nombreB = areasMap[b] || '';
        return nombreA.localeCompare(nombreB);
      });
      
      this.areasOptions = [
        { text: "Todas las áreas", value: null },
        ...areasArray.map(id => ({
          text: areasMap[id] || `Área ${id}`,
          value: id
        }))
      ];
      
      console.log("Áreas disponibles:", this.areasOptions.length - 1);
    },
    
    filterByArea() {
      if (!this.selectedArea) {
        this.filteredReportes = [...this.reportes];
      } else {
        this.filteredReportes = this.reportes.filter(
          item => item.cc_id_area_requerimiento == this.selectedArea
        );
      }
    },
    
    mostrarMensaje(mensaje, tipo = 'error') {
      this.snackbar = true;
      this.text = mensaje;
    },
    
    // Método para cerrar diálogo de observación
    close3() {
      this.dialog3 = false;
    },
    
    // Ver conversación
    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      this.chatItem =
        typeof item.conversacion === "string"
          ? JSON.parse(item.conversacion)
          : item.conversacion || [];
    },
    
    // Ver observación (NUEVO)
    verObservacion(item) {
      this.dialog3 = true;
      this.observacion = item.observaciones;
    },
    
    // Ver historial (NUEVO)
    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },
    
    // Eliminar reporte erróneo
    deleteReport(item) {
      swal({
        title: "Este registro será eliminado permanentemente.",
        text: "Una vez eliminado no se podrá recuperar.",
        icon: "warning",
        buttons: ["Cancelar", true],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axios
            .get(`${env.endpoint}callcenter/delete_caso?id=${item.cc_id_caso}`)
            .then((res) => {
              this.searchReports();
              swal("Registro eliminado con éxito!", { icon: "success" });
            })
            .catch((error) => {
              swal("Error al eliminar el registro", { icon: "error" });
            });
        } else {
          swal("Proceso de eliminación cancelado");
        }
      });
    },
    
    // Ver evidencias
    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = true;
      this.evidencias = [];
      
      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias || [];
        })
        .catch((error) => {
          this.mostrarMensaje("Error al cargar las evidencias");
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },
    
    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },
    
    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },
    
    descargarImagen() {
      const link = document.createElement("a");
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    
    verImagen(item) {
      if (item.cc_ruta && item.cc_ruta !== '' && item.cc_ruta !== '0') {
        const rutas = item.cc_ruta.split(',').map(r => r.trim()).filter(r => r);
        if (rutas.length > 0) {
          this.cc_ruta = rutas[0];
          this.dialogImagenCierre = true;
        }
      }
    },
    
    aumentarImagen() {
      this.imagenSeleccionada = this.cc_ruta;
      this.dialogImagenCierre = false;
      this.dialogImagenCompleta = true;
    },
    
    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },
    
    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },
    
    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },
    
    downloadFile(url) {
      window.open(url, "_blank");
    },
    
    async downloadExcelJS() {
      if (!this.reportes.length) {
        this.mostrarMensaje("No hay datos para exportar");
        return;
      }
      
      this.loading3 = true;

      try {
        const workbook = new ExcelJS.Workbook();
        const reportesPorArea = {};
        
        this.reportes.forEach(reporte => {
          const idArea = reporte.cc_id_area_requerimiento;
          const nombreArea = reporte.cc_nombre_area || `Área ${idArea}`;
          
          if (!reportesPorArea[idArea]) {
            reportesPorArea[idArea] = {
              nombre: nombreArea,
              reportes: []
            };
          }
          reportesPorArea[idArea].reportes.push(reporte);
        });
        
        for (const [idArea, areaData] of Object.entries(reportesPorArea)) {
          const nombreHoja = areaData.nombre.substring(0, 31);
          const ws = workbook.addWorksheet(nombreHoja);
          await this.crearHojaExcel(ws, areaData.reportes, areaData.nombre);
        }
        
        if (Object.keys(reportesPorArea).length > 5) {
          const wsResumen = workbook.addWorksheet("TODOS LOS CASOS");
          await this.crearHojaExcel(wsResumen, this.reportes, "TODAS LAS ÁREAS");
        }

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(
          new Blob([buffer]),
          `Reporte_General_${this.dateInit}_al_${this.dateEnd}.xlsx`
        );
      } catch (e) {
        console.error("Error exportando Excel:", e);
        this.mostrarMensaje("Error al exportar a Excel");
      } finally {
        this.loading3 = false;
      }
    },
    
    async crearHojaExcel(ws, datos, nombreArea) {
      try {
        const novaLogo = await fetch(
          require("@/assets/nova/Logo_nova.png")
        ).then((r) => r.arrayBuffer());
        const novaId = ws.workbook.addImage({
          buffer: novaLogo,
          extension: "png",
        });
        ws.addImage(novaId, {
          tl: { col: 0, row: 0 },
          ext: { width: 120, height: 60 },
        });
        
        const tieneFacilisimo = datos.some(r => 
          (r.nombreEmpresa && r.nombreEmpresa.toUpperCase().includes('FACILISIMO')) || r.idEmpresa == 1
        );
        const tieneApostar = datos.some(r => 
          (r.nombreEmpresa && r.nombreEmpresa.toUpperCase().includes('APOSTAR')) || r.idEmpresa == 2
        );
        
        if (tieneFacilisimo) {
          const facilisimoLogo = await fetch(
            require("@/assets/LOGO-FACILISIMO-GRIS.png")
          ).then((r) => r.arrayBuffer());
          const facilisimoId = ws.workbook.addImage({
            buffer: facilisimoLogo,
            extension: "png",
          });
          ws.addImage(facilisimoId, {
            tl: { col: tieneApostar ? 7 : 9, row: 0 },
            ext: { width: 120, height: 60 },
          });
        }
        
        if (tieneApostar) {
          const apostarLogo = await fetch(
            require("@/assets/nova/LOGO APOSTAR-06.png")
          ).then((r) => r.arrayBuffer());
          const apostarId = ws.workbook.addImage({
            buffer: apostarLogo,
            extension: "png",
          });
          ws.addImage(apostarId, {
            tl: { col: tieneFacilisimo ? 9 : 9, row: 0 },
            ext: { width: 120, height: 60 },
          });
        }
      } catch (e) {
        console.log("Error cargando logos:", e);
      }
      
      ws.mergeCells("C1", "I2");
      ws.getCell("C1").value = `REPORTE GENERAL - ${nombreArea}`;
      ws.getCell("C1").alignment = {
        vertical: "middle",
        horizontal: "center",
      };
      ws.getCell("C1").font = {
        size: 18,
        bold: true,
        color: { argb: "FFFFFFFF" },
      };
      
      for (let row = 1; row <= 2; row++) {
        for (let col = 1; col <= 14; col++) {
          const cell = ws.getCell(row, col);
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF294697" },
          };
        }
      }
      ws.getRow(1).height = 30;
      ws.getRow(2).height = 30;
      
      ws.addRow([]);
      
      ws.addRow([
        "ID Caso",
        "Área",
        "Requerimiento",
        "Estado",
        "IP/Punto ID",
        "Municipio",
        "Punto",
        "Empresa",
        "Fecha apertura",
        "Fecha cierre",
        "Especialista",
        "Observaciones",
        "Conversacion",
        "Prioridad",
      ]);
      
      ws.getRow(4).eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FF1D3C7F" },
        };
        cell.font = { color: { argb: "FFFFFFFF" }, bold: true };
        cell.border = {
          top: { style: "medium", color: { argb: "FF000000" } },
          left: { style: "medium", color: { argb: "FF000000" } },
          bottom: { style: "medium", color: { argb: "FF000000" } },
          right: { style: "medium", color: { argb: "FF000000" } },
        };
      });
      
      datos.forEach((r) => {
        let estadoTexto = "";
        if (r.oculto == 0 && r.cerrados == 0) {
          estadoTexto = "ERRONEO";
        } else if (r.vencido == 1) {
          estadoTexto = "VENCIDO";
        } else {
          estadoTexto = this.formatearEstado(r.cerrados);
        }
        
        ws.addRow([
          r.cc_id_caso,
          r.cc_nombre_area || "SIN ÁREA",
          r.cc_nombre_requerimiento,
          estadoTexto,
          r.ip || "SIN IP",
          r.municipio || "SIN MUNICIPIO",
          r.punto || "SIN PUNTO",
          r.nombreEmpresa || "SIN EMPRESA",
          r.fecha_inicio,
          r.fecha_cierre || "Sin cerrar",
          r.nombre || "SIN ASIGNAR",
          r.observaciones || "",
          r.conversacion || "",
          this.formatearPrioridad(r.cc_prioridad_requerimiento),
        ]);
      });
      
      ws.columns = [
        { width: 12 },
        { width: 20 },
        { width: 30 },
        { width: 15 },
        { width: 15 },
        { width: 20 },
        { width: 25 },
        { width: 15 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
        { width: 30 },
        { width: 12 },
      ];
    },
  },
  
  watch: {
    reportes: {
      handler(newVal) {
        this.filteredReportes = [...newVal];
        this.construirOpcionesAreas(newVal);
      },
      deep: true
    }
  },
};
</script>

<style scoped>
.text-field {
  border: 2px solid #111c3d;
  padding: 5px;
  border-radius: 5px;
}

.contenedor-ppal {
  border: 1px solid #111c3d;
  padding-bottom: 40px !important;
  border-radius: 5px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.loader {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #2981ec;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  -webkit-mask: var(--_m);
  mask: var(--_m);
  -webkit-mask-composite: source-out;
  mask-composite: subtract;
  animation: l3 1s infinite linear;
}
@keyframes l3 {
  to {
    transform: rotate(1turn);
  }
}

/* Estilo para botón consultar */
.btn-consultar {
  min-width: 120px;
  font-size: 0.9rem;
  padding: 0 12px;
  height: 45px !important;
}

/* Estilo para botón Excel - mismo tamaño que consultar */
.btn-excel {
  min-width: 120px;
  font-size: 0.9rem;
  padding: 0 12px;
  height: 45px !important;
}

@media (max-width: 600px) {
  .btn-consultar, .btn-excel {
    width: 100% !important;
    min-width: unset !important;
    font-size: 0.9rem !important;
    margin-bottom: 8px !important;
    padding: 8px 0 !important;
    height: 45px !important;
  }
  .v-col {
    padding-left: 4px !important;
    padding-right: 4px !important;
    margin-bottom: 8px !important;
  }
  .v-text-field {
    font-size: 0.95rem !important;
  }
  .v-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

/* Estilo para mensajes del chat */
.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}
</style>